// extracted by mini-css-extract-plugin
export default {"controlRow":"MGInput_controlRow__3vb0n","leftIcon":"MGInput_leftIcon__Bu7nP","rightIcon":"MGInput_rightIcon__6iFvz","rightIconButton":"MGInput_rightIconButton__PDsLc"};